import { render, staticRenderFns } from "./RotacionAgenciaReportPage.vue?vue&type=template&id=54c0cfb2"
import script from "./RotacionAgenciaReportPage.vue?vue&type=script&lang=js"
export * from "./RotacionAgenciaReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports